import { OrangeTickIcon } from "./icons/orange-tick-icon";
import { DownloadArticlesIcon } from "./icons/download-articles-icon";
import { StayingInformedIcon } from "./icons/staying-informed-icon";
import { CredibleNewsIcon } from "./icons/credible-news-icon";
import { LegacyTrustIcon } from "./icons/legacy-trust-icon";

export { OrangeTickIcon, DownloadArticlesIcon, StayingInformedIcon, CredibleNewsIcon, LegacyTrustIcon };

export const hardcodedCards = [
  {
    title: "ಹಲವು ಸಾಧನಗಳಲ್ಲಿ ನೋಡಿ",
    description: "ವೆಬ್ ಮತ್ತು ಮೊಬೈಲ್ ಎರಡೂ ಸಾಧನಗಳಲ್ಲಿ ಏಕಕಾಲಕ್ಕೆ ನಿಮ್ಮ ಇ-ಪೇಪರ್ ಓದಿರಿ.",
    icon: OrangeTickIcon
  },
  {
    title: "ಮಾಹಿತಿ ದೊರಕಿಸುವಲ್ಲಿ ನಿಮ್ಮ ಪಾಲುದಾರ",
    description: "ಸ್ಥಳೀಯ ಸುದ್ದಿಗಳಿಂದ ಹಿಡಿದು ಜಾಗತಿಕ ವಿದ್ಯಮಾನಗಳವರೆಗೆ ಖಚಿತ ಮಾಹಿತಿಗಳನ್ನೇ ಒದಗಿಸುತ್ತೇವೆ.",
    icon: StayingInformedIcon
  },
  {
    title: "ಪ್ರತಿದಿನವೂ ಭರಪೂರ ವಿಶ್ವಾಸಾರ್ಹ ಸುದ್ದಿಗಳು",
    description: "ನೀವು ನಂಬಬಹುದಾದ ವಿಶ್ವಸನೀಯ ಸುದ್ದಿಗಳೊಂದಿಗೆ, ಪ್ರತಿದಿನದ ಬೆಳಗನ್ನು ಆರಂಭಿಸಿ.",
    icon: CredibleNewsIcon
  },
  {
    title: "ಡೌನ್ಲೋಡ್ ಮಾಡಬಹುದಾದ ಲೇಖನಗಳು",
    description: "ಸುಲಭವಾಗಿ ಹಂಚಿಕೊಳ್ಳಲು ಮತ್ತು ಆಫ್ಲೈನ್ ಓದಲು ಚಿತ್ರ ರೂಪದಲ್ಲಿ ಲೇಖನಗಳನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡಿಕೊಳ್ಳಿ.",
    icon: DownloadArticlesIcon
  },
  {
    title: "ವಿಶ್ವಾಸಪೂರ್ಣ ಪರಂಪರೆ",
    description: "75 ವರ್ಷಗಳಿಂದಲೂ ನಿಮ್ಮ ವಿಶ್ವಾಸಾರ್ಹ ಧ್ವನಿ, ಇನ್ನೂ ಮುಂದುವರಿಯುತ್ತಿದೆ.",
    icon: LegacyTrustIcon
  }
];
